import React from 'react';

class FormBuilder_FieldViewer extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    if (this.props.onChange) {
      const value = e.currentTarget.value;

      return this.props.onChange(value);
    }
  }

  render() {
    let renderedField = null;

    const type = this.props.field.type;
    const fieldId = this.props.field.id || 'field-' + Math.random().toString(36).substring(2);

    if (!this.props.field.name) {
      return <p className="text-danger"><i className="fa fa-exclamation-triangle" /> Field {this.props.field.type} "{this.props.field.label}" has no name</p>;
    }

    switch (type) {
      case 'color':
      case 'date':
      case 'datetime-local':
      case 'email':
      case 'month':
      case 'password':
      case 'search':
      case 'tel':
      case 'text':
      case 'time':
      case 'url':
      case 'week':
        renderedField = (
          <input
            type={type}

            className="form-control"

            id={fieldId}
            name={this.props.field.name}
            placeholder={this.props.field.placeholder || ''}
            disabled={this.props.field.value !== undefined ? 'disabled' : null}

            value={this.props.value}
            onChange={this.handleChange}
          />
        );
        break;
      case 'textarea':
        renderedField = (
          <textarea
            className="form-control"

            id={fieldId}
            name={this.props.field.name}
            placeholder={this.props.field.placeholder || ''}
            disabled={this.props.field.value !== undefined ? 'disabled' : null}

            value={this.props.value}
            onChange={this.handleChange}

            style={{minHeight: '10rem'}}
          />
        );
        break;
      case 'select':
          renderedField = (
            <select
              className="form-control"

              id={fieldId}
              name={this.props.field.name}
              placeholder={this.props.field.placeholder || ''}
              disabled={this.props.field.value !== undefined ? 'disabled' : null}

              value={this.props.value}
              onChange={this.handleChange}
            >
              <option value="">-- seleziona --</option>
              {
                this.props.field.options.map((option) => {
                  return <option value={option.value}>{option.label}</option>;
                })
              }
            </select>
          );
          break;
      default:
        return (
          <div className="alert alert-danger"><i className="fa fa-exclamation-triangle" /> unknown field type: {type} for field #{fieldId}</div>
        );
    }

    return (
      <div className="form-group">
        <label for={fieldId}>{this.props.field.label}</label>
        {renderedField}

        {this.props.field.help ? <small className="form-text text-muted">{this.props.field.help}</small> : ''}
      </div>
    );
  }
}

export default FormBuilder_FieldViewer;


// WEBPACK FOOTER //
// ./src/components/marketing/surveys/form_builder/FormBuilder_FieldViewer.js